<template>
    <div :class="['layout', _isMobile() ? 'mobile' : '']">
        <router-view />
    </div>
  </template>
  
  <script>
  import { mixinDevice } from "@/utils/mixin.js";
  export default {
    name: "FullScreenLayout",
    mixins: [mixinDevice],
    components: {
    },
    data() {
      return {
      };
    },
    created() {
  
    },
  };
  </script>
  <style>
    a *{
      transition: all 0.1s ease;
    }
  </style>
  <style lang="less" scoped>
  .layout {
    min-height: 100vh;
    /deep/.ant-list-pagination {
      text-align: center;
    }
    // background: url(~@/assets/background.svg);
  }
  </style>